import React, { useMemo } from 'react';
import AppShell from '../layouts/AppShell';
import TemplatesLayout from '../layouts/TemplatesLayout';
import QuickReplyManager from '../components/QuickReplyManager';
import { buildNavigationItems } from '../utils/navigationConfig';
import { hasPermission, hasAnyPermission } from '../utils/permissionUtils';

const QuickRepliesPage = ({ user, onLogout }) => {
  const canManageTemplates = useMemo(() => hasPermission(user, 'template:manage'), [user]);
  const canManageIntegrations = useMemo(() => hasPermission(user, 'integration:manage'), [user]);
  const canManagePositions = useMemo(() => hasPermission(user, 'position:manage'), [user]);
  const canManageTeams = useMemo(() => hasPermission(user, 'team:manage'), [user]);
  const canViewUserRoster = useMemo(() => hasAnyPermission(user, ['position:assign', 'position:manage', 'user:manage']), [user]);
  const canInviteUsers = useMemo(() => hasPermission(user, 'user:invite'), [user]);
  const canViewStats = useMemo(() => hasPermission(user, 'stats:view'), [user]);
  const canModerateComments = useMemo(() => hasPermission(user, 'comment:moderate'), [user]);
  const navItems = useMemo(() => buildNavigationItems({ canManageTemplates, canViewUserRoster, canManagePositions, canManageTeams, canInviteUsers, canViewStats, canManageIntegrations, canModerateComments }), [canManageTemplates, canViewUserRoster, canManagePositions, canManageTeams, canInviteUsers, canViewStats, canManageIntegrations, canModerateComments]);

  return <AppShell user={user} navItems={navItems} onLogout={onLogout}>
    <TemplatesLayout title="Quick Replies" description="Create shared WhatsApp replies for counsellors.">
      <QuickReplyManager />
    </TemplatesLayout>
  </AppShell>;
};

export default QuickRepliesPage;
